import toast from "react-hot-toast";

const paths = {
  login: "login-path",
};

async function fetchBackend(endpoint, method, auth, body, params) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const fetchObject = { method, headers };
  const path = paths[endpoint] || endpoint;
  let url = `https://api.greenzonetechnologies.com.ng/medicals/api${path}`;

  if (body) {
    fetchObject.body = JSON.stringify(body);
  }

  if (params) {
    const paramsArray = Object.keys(params).map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    );
    url += `?${paramsArray.join("&")}`;
  }

  if (auth) {
    const token = sessionStorage.getItem("token");
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  try {
    const response = await fetch(url, fetchObject);

    if (!response.ok) {
      // Attempt to parse error JSON from response
      const errorResponseData = await response.json();

      // Only show toast errors for non-GET requests
      const showToastError = method !== "GET";

      // Handle specific error cases and show toast messages
      if (errorResponseData.statusCode === 500) {
        const errorMessage =
          errorResponseData.errorData && errorResponseData.errorData.length > 0
            ? errorResponseData.errorData[0]
            : "Internal server error occurred";

        console.error("Server Internal Error:", {
          reference: errorResponseData.reference,
          statusCode: errorResponseData.statusCode,
          exceptionType: errorResponseData.exceptionType,
          errorData: errorResponseData.errorData,
          timeStamp: errorResponseData.timeStamp,
        });

        if (showToastError) {
          toast.error(`Server Error: ${errorMessage}`);
        }
      } else if (errorResponseData.statusCode === 400) {
        const errorMessage =
          errorResponseData.errorData && errorResponseData.errorData.length > 0
            ? errorResponseData.errorData[0]
            : "Bad request";

        if (showToastError) {
          toast.error(errorMessage);
        }
      } else if (
        errorResponseData.errorData &&
        Array.isArray(errorResponseData.errorData)
      ) {
        const errorMessage = errorResponseData.errorData[0];
        console.error("API Validation Error:", errorMessage);

        if (showToastError) {
          toast.error(errorMessage);
        }
      } else if (errorResponseData.message) {
        console.error("General Server Message:", errorResponseData.message);

        if (showToastError) {
          toast.error(errorResponseData.message);
        }
      }

      // Return the error response data as-is
      return errorResponseData;
    }

    // For successful responses, parse the JSON
    return response.json();
  } catch (error) {
    console.error("Fetch API error:", error);

    // Only show toast errors for non-GET requests
    const showToastError = method !== "GET";

    // Handle network and parsing errors
    if (error instanceof TypeError && error.message === "Failed to fetch") {
      console.error("Network or CORS error: Unable to connect to backend.");

      if (showToastError) {
        toast.error(
          "Network error: Could not connect to the server. Please check your internet connection."
        );
      }

      // Return a network error response
      return {
        statusCode: 0,
        exceptionType: "NetworkError",
        errorData: ["Could not connect to the server"],
        message: "Network error occurred",
      };
    }

    // Handle JSON parsing errors or other unexpected errors
    console.error("An unexpected error occurred:", error.message);

    if (showToastError) {
      toast.error("An unexpected error occurred. Please try again.");
    }

    // Return a generic error response
    return {
      statusCode: 0,
      exceptionType: "UnexpectedError",
      errorData: [error.message || "An unexpected error occurred"],
      message: error.message || "An unexpected error occurred",
    };
  }
}

export const get = (endpoint, params, auth = true) =>
  fetchBackend(endpoint, "GET", auth, null, params);

export const post = (endpoint, body, auth = true) =>
  fetchBackend(endpoint, "POST", auth, body);

export const put = (endpoint, body, auth = true) =>
  fetchBackend(endpoint, "PUT", auth, body);

export const del = (endpoint, body, auth = true) =>
  fetchBackend(endpoint, "DELETE", auth, body);

function checkHttpStatus(response) {
  if (response && response.ok) {
    return response;
  }

  console.log(response);

  const errorText =
    response && response.statusText ? response.statusText : "Unknown Error";
  const error = new Error(errorText);
  error.response = response;
}

function parseJSON(response) {
  return response && response?.json();
}
